import { useMemo } from 'react';

import { PdpCatalogProductImageType } from '../graphql/pdp-base-info_types.2';
import { useCatalogProductIdParams } from '../hooks/useCatalogProductIdParams';
import { usePdpBaseInfo } from './usePdpBaseInfo';

export function useProductThumbnail() {
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);

  const { image_list, main_image } = useMemo(() => {
    const imageOrder = [
      PdpCatalogProductImageType.MAIN,
      PdpCatalogProductImageType.SUB,
      PdpCatalogProductImageType.CONTENT,
    ];
    const isGif = (url: string) => /\.gif$/.test(url);

    const main_image = [...product.product_image_list].sort(
      (a, b) => imageOrder.indexOf(a.image_type) - imageOrder.indexOf(b.image_type),
    )[0];

    const image_list = [...product.product_image_list]
      .sort((a, b) => {
        if (isGif(a.origin_url) && !isGif(b.origin_url)) {
          return 1;
        } else if (!isGif(a.origin_url) && isGif(b.origin_url)) {
          return -1;
        } else {
          return imageOrder.indexOf(a.image_type) - imageOrder.indexOf(b.image_type);
        }
      })
      .map(({ id, pdp_thumbnail_url, url, origin_url, pdp_static_image_url, origin_width, origin_height }) => ({
        id,
        url: pdp_thumbnail_url || url,
        origin_url,
        static_url: pdp_static_image_url ? pdp_static_image_url : null,
        origin_width,
        origin_height,
      }));

    return {
      image_list,
      main_image,
    };
  }, [product]);

  return {
    image_list,
    url: main_image?.url ?? '',
    is_hide: !product.id,
    first_image_url: image_list.length
      ? image_list[0].static_url
        ? image_list[0].static_url
        : image_list[0].url || ''
      : '',
  };
}
